module.exports = __webpack_public_path__ + "img/canada-breast-cancer-female.208858c7.png";